/**
 * Accordion — exclusive behavior for <details> sibling pattern.
 *
 * <details> contains only <summary>; content is a sibling <div>.
 * CSS handles animation via grid-template-rows 0fr/1fr on the sibling.
 *
 * This script handles:
 *   1. Exclusive behavior — opening one accordion closes its siblings.
 *   2. Table scroll — wraps <table> elements inside accordion content
 *      in a scrollable container so long tables don't stretch the page.
 */
(() => {
  /* --- Exclusive accordion toggle --- */
  document.addEventListener('toggle', (e) => {
    const details = e.target;
    if (details.tagName !== 'DETAILS' || !details.open) return;

    const accordion = details.closest('.accordion');
    if (!accordion) return;

    const parent = accordion.parentElement;
    if (!parent) return;

    parent
      .querySelectorAll(':scope > .accordion > details[open]')
      .forEach((sibling) => {
        if (sibling !== details) sibling.removeAttribute('open');
      });
  }, true); // useCapture — toggle doesn't bubble

  /* --- Wrap tables in scrollable containers --- */
  document.querySelectorAll('.accordion__content-inner table').forEach((table) => {
    if (table.parentElement.classList.contains('table-scroll-wrapper')) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'table-scroll-wrapper';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
})();
